import { isPenceSterling } from './quoteNormalization';

export const getCurrencySymbol = (code: string) => {
    if (isPenceSterling({ currency: code })) return '£';
    switch (code) {
        case 'USD':
            return '$';
        case 'EUR':
            return '€';
        case 'GBP':
            return '£';
        default:
            return '$';
    }
};

const EXCHANGE_RATES: Record<string, number> = {
    GBP: 1,
    USD: 1.28,
    EUR: 1.18,
    GBX: 0.01, // Pence to Pounds
};

export const convertCurrency = (amount: number, fromCurrency: string, toCurrency: string): number => {
    if (!amount) return 0;
    const fromRaw = fromCurrency || 'GBP';
    const toRaw = toCurrency || 'GBP';
    const from = fromRaw.toUpperCase();
    const to = toRaw.toUpperCase();
    const fromIsPence = isPenceSterling({ currency: fromRaw });
    const toIsPence = isPenceSterling({ currency: toRaw });
    if (from === to && fromIsPence === toIsPence) return amount;

    const amountInGBP = fromIsPence ? amount * 0.01 : amount * (1 / (EXCHANGE_RATES[from] || 1));
    if (toIsPence) {
        return amountInGBP / 0.01;
    }
    return amountInGBP * (EXCHANGE_RATES[to] || 1);
};
